import React, { FC, ReactNode } from 'react';
import { Animated, View } from 'react-native';
import ReactDOM from 'react-dom';
import { Portal } from 'react-native-portalize';
import OutsidePressHandler from 'react-native-outside-press';
import ColorWrapper, { WithColor } from '@styles/colors';
import { isWeb } from '@helpers';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { useManageSidePanel } from './hooks/useManageSidePanel';

export interface SidePanelProps extends WithColor {
  isOpen: boolean;
  onClose: () => void;
  width: number;
  children: ReactNode;
  topOffset?: number;
  bottomOffset?: number;
  animationDuration?: number;
  zIndex?: number;
  scale?: ScaleFunction;
  closeOnEscape?: boolean;
}

const SidePanel: FC<SidePanelProps> = (props) => {
  const { isMounted, panelRef, renderedChildren, style } = useManageSidePanel(props);

  if (!isMounted) return null;

  if (isWeb && typeof document !== 'undefined') {
    return ReactDOM.createPortal(
      <Animated.View ref={panelRef as React.Ref<View>} style={style}>
        {renderedChildren}
      </Animated.View>,
      document.body
    );
  }

  return (
    <Portal>
      <Animated.View ref={panelRef as React.Ref<View>} style={style}>
        <OutsidePressHandler onOutsidePress={props.onClose} disabled={!props.isOpen} style={{ flex: 1 }}>
          {renderedChildren}
        </OutsidePressHandler>
      </Animated.View>
    </Portal>
  );
};

export default ColorWrapper(SidePanel);
